import { all_routes } from "../../../feature-module/router/all_routes";
import { useSelector } from "react-redux";
const routes = all_routes;

export const HorizontalSidebarData = () => {
  const user = useSelector((state: any) => state.user.user);

  if (user) {
    const crmMenu = {
      menuValue: "CRM",
      hasSubRoute: true,
      showSubRoute: false,
      base: "crm",
      icon: "user-star",
      subMenus: [
        {
          menuValue: "Contacts",
          route: routes.contactGrid,
          base: "contact",
        },
        {
          menuValue: "Companies",
          route: routes.companiesGrid,
          base: "company",
        },
        {
          menuValue: "Deals",
          route: routes.dealsList,
          base: "deals",
        },
        {
          menuValue: "Deals Transfer",
          route: routes.dealsTransfer,
          base: "dealsTransfer",
        },
        {
          menuValue: "Leads",
          route: routes.leadsList,
          base: "leads",
        },
        {
          menuValue: "Leads Transfer",
          route: routes.leadsTransfer,
          base: "leadsTransfer",
        },
        {
          menuValue: "Leads In Queue",
          route: routes.leadsqueue,
          base: "leadqueue",
        },
        {
          menuValue: "Leads Form",
          route: routes.leadsForm,
          base: "leadform",
        },
        {
          menuValue: "Pipelines",
          route: routes.pipeline,
          base: "pipeline",
        },
        {
          menuValue: "Analytics",
          route: routes.analytics,
          base: "analytics",
        },
        {
          menuValue: "Activities",
          route: routes.activities,
          base: "activities",
        },
        {
          menuValue: "CRM Settings",
          route: routes.crmSettings,
          base: "settings",
        },
        {
          menuValue: "Call Logs",
          route: routes.callLogs,
          base: "call_logs",
        },
        {
          menuValue: "Bulk upload",
          route: routes.bulkUpload,
          base: "call_logs",
        },
      ],
    };
    return [
      {
        title: "Main",
        showAsTab: false,
        separateRoute: false,
        menu: [
          {
            menuValue: "Super Admin",
            hasSubRoute: true,
            showSubRoute: false,
            icon: "user-star",
            base: "super-admin",
            subMenus: [
              {
                menuValue: "Dashboard",
                route: routes.superAdminDashboard,
                base: "super-admin-dashboard",
              },
              {
                menuValue: "Companies",
                route: routes.superAdminCompanies,
                base: "companies",
              },
              {
                menuValue: "Subscriptions",
                route: routes.superAdminSubscriptions,
                base: "subscriptions",
              },
              {
                menuValue: "Packages",
                route: routes.superAdminPackages,
                base: "packages",
                base2: "packages-grid",
              },
              // {
              //   menuValue: 'Domain',
              //   route: routes.superAdminDomain,
              //   base: 'domain',
              // },
              // {
              //   menuValue: 'Purchase Transaction',
              //   route: routes.superAdminPurchaseTransaction,
              //   base: 'purchase-transaction',
              // },
            ],
          },
          {
            menuValue: "Main Menu",
            hasSubRoute: true,
            showSubRoute: false,
            icon: "user-star",
            base: "main-menu",
            subMenus: [
              {
                menuValue: "Dashboard",
                base: "dashboard",
                customSubmenuTwo: true,
                subMenusTwo: [
                  ...(user.userDetails.role_char.toLowerCase() === "admin" ||
                    user.userDetails.role_char.toLowerCase() === "employeeadmin"
                    ? [
                      {
                        menuValue: "Dashboard",
                        route: routes.adminDashboard,
                        base: "index",
                      },
                      // {
                      //   menuValue: "CMS Dashboard",
                      //   route: routes.cmsLeadDashboard,
                      //   base: "leads",
                      // },
                    ]
                    : [
                      {
                        menuValue: "Dashboard",
                        route: routes.adminDashboard,
                        base: "index",
                      },
                    ]),

                  // {
                  //   menuValue: "Employee Dashboard",
                  //   route: routes.employeeDashboard,
                  //   base: "employee",
                  // },

                  // ...(user.userDetails?.menu_items?.includes("Deals") &&
                  // user.userDetails.role_char.toLowerCase() != "admin" &&
                  // user.userDetails.role_char.toLowerCase() != "employeeadmin"
                  //   ? [
                  //       {
                  //         menuValue: "Deals Dashboard",
                  //         route: routes.dealsDashboard,
                  //         base: "deals",
                  //       },
                  //     ]
                  //   : []),
                  // ...(user.userDetails?.menu_items?.includes("Leads") &&
                  // user.userDetails.role_char.toLowerCase() != "admin" &&
                  // user.userDetails.role_char.toLowerCase() != "employeeadmin"
                  //   ? [
                  //       {
                  //         menuValue: "Leads Dashboard",
                  //         route: routes.leadsDashboard,
                  //         base: "leads",
                  //       },
                  //     ]
                  //   : []),
                ],
              },
            ],
          },
          crmMenu,
          {
            menuValue: "HRM",
            hasSubRoute: true,
            showSubRoute: false,
            base: "hrm",
            icon: "user-star",
            subMenus: [
              {
                menuValue: "Employees",
                base: "employee",
                customSubmenuTwo: true,
                subMenusTwo: [
                  {
                    menuValue: "Employees List",
                    route: routes.employeeList,
                    base: "employees",
                    base2: "employee-list",
                  },
                  {
                    menuValue: "Departments",
                    route: routes.departments,
                    base: "departments",
                  },
                  {
                    menuValue: "Designations",
                    route: routes.designations,
                    base: "designations",
                  },
                  // {
                  //   menuValue: "Policies",
                  //   route: routes.policy,
                  //   base: "employees",
                  //   base2: "policy",
                  // },
                ],
              },
              {
                menuValue: "Attendance (Admin)",
                base: "attendance",
                customSubmenuTwo: true,
                subMenusTwo: [
                  {
                    menuValue: "Leaves",
                    route: routes.leaveadmin,
                    base: "attendances",
                    base2: "leabe-list",
                  },
                  {
                    menuValue: "Attendance",
                    route: routes.attendanceadmin,
                    base: "attendances",
                    base2: "attendance-admin",
                  },
                ],
              },
              {
                menuValue: "Attendance (Employee)",
                base: "attendance",
                customSubmenuTwo: true,
                subMenusTwo: [
                  {
                    menuValue: "Leaves",
                    route: routes.leaveemployee,
                    base: "attendances",
                    base2: "leabe-list",
                  },
                  {
                    menuValue: "Attendance",
                    route: routes.attendanceemployee,
                    base: "attendances",
                    base2: "attendance-admin",
                  },
                ],
              },
            ],
          },
          {
            menuValue: "Administration",
            hasSubRouteTwo: true,
            showSubRoute: false,
            icon: "user-star",
            base: "jobs",
            base2: "candidates",
            base3: "refferals",
            base4: "sales",
            base5: "accounting",
            base6: "payroll",
            base7: "assets",
            base8: "support",
            base9: "user-management",
            base10: "reports",
            base11: "ticket-setting",
            subMenus: [
              {
                menuValue: "Assets",
                base: "assets",
                customSubmenuTwo: true,
                subMenusTwo:
                  user?.userDetails?.department_access == 0 &&
                    user?.userDetails?.role_char.toLowerCase() == "employeeadmin"
                    ? [
                      {
                        label: "Assign Assets",
                        route: routes.assignAssets,
                        base: "assign-assets",
                      },
                    ]
                    : [
                      {
                        label: "Asset Stocks",
                        link: routes.assetStocks,
                        base: "asset-stocks",
                      },
                      {
                        label: "Assign Assets",
                        link: routes.assignAssets,
                        base: "assign-assets",
                      },
                      {
                        label: "Asset Categories",
                        link: routes.assetCategories,
                        base: "asset-categories",
                      },
                      {
                        label: "Asset Products",
                        link: routes.assetProducts,
                        base: "asset-products",
                      },
                      {
                        label: "Asset Locations",
                        link: routes.assetLocations,
                        base: "asset-locations",
                      },
                    ],
              },
              {
                menuValue: "Ticket Settings",
                base: "ticket-setting",
                customSubmenuTwo: true,
                subMenusTwo: [
                  {
                    label: "Tickets Category",
                    link: routes.ticketCategories,
                    base: "ticket-details",
                  },
                ],
              },
              {
                menuValue: "Requirment",
                base: "jobs",
                base2: "candidates",
                base3: "refferals",
                customSubmenuTwo: true,
                subMenusTwo: [

                  {
                    menuValue: "Jobs",
                    route: routes.jobgrid,
                    base: "jobs-grid",
                  },
                ],
              },
              {
                menuValue: "Sales",
                base: "sales",
                customSubmenuTwo: true,
                subMenusTwo: [
                  {
                    menuValue: "Estimates",
                    route: routes.estimate,
                    base: "estimates",
                  },
                  {
                    menuValue: "Invoices",
                    route: routes.invoice,
                    base: "invoices",
                  },
                  {
                    menuValue: "Payments",
                    route: routes.payments,
                    base: "payments",
                  },
                  {
                    menuValue: "Expenses",
                    route: routes.expenses,
                    base: "expenses",
                  },
                  {
                    menuValue: "Provident Fund",
                    route: routes.providentfund,
                    base: "provident-fund",
                  },
                  {
                    menuValue: "Taxes",
                    route: routes.taxes,
                    base: "taxes",
                  },
                ],
              },
              {
                menuValue: "Accounting",
                base: "accounting",
                customSubmenuTwo: true,
                subMenusTwo: [
                  {
                    menuValue: "Categories",
                    route: "/accounting/categories",
                    base: "categories",
                  },
                  {
                    menuValue: "Budgets",
                    route: "/accounting/budgets",
                    base: "budgets",
                  },
                  {
                    menuValue: "Budget Expenses",
                    route: "/accounting/budget-expenses",
                    base: "budget-expenses",
                  },
                  {
                    menuValue: "Budget Revenues",
                    route: "/accounting/budget-revenues",
                    base: "budget-revenues",
                  },
                ],
              },
              {
                menuValue: "Payroll",
                base: "payroll",
                customSubmenuTwo: true,
                subMenusTwo: [
                  {
                    menuValue: "Employee Salary",
                    route: "/payroll/employee-salary",
                    base: "employee-salary",
                  },
                  {
                    menuValue: "Payslip",
                    route: "/payroll/payslip",
                    base: "payslip",
                  },
                  {
                    menuValue: "Payroll Items",
                    route: "/payroll/payroll-items",
                    base: "payroll-items",
                  },
                ],
              },
              {
                menuValue: "Help & Supports",
                base: "supports",
                customSubmenuTwo: true,
                subMenusTwo: [
                  {
                    menuValue: "Knowledge Base",
                    route: routes.knowledgebase,
                    base: "knowledgebase",
                    base2: "knowledgebase-view",
                    base3: "knowledgebase-details",
                  },
                  {
                    menuValue: "Activities",
                    route: routes.activities,
                    base: "activities",
                  },
                ],
              },
              {
                menuValue: "User Management",
                base: "user-management",
                customSubmenuTwo: true,
                subMenusTwo: [
                  {
                    menuValue: "Users",
                    route: routes.manageusers,
                    base: "users",
                  },
                  {
                    menuValue: "Roles & Permissions",
                    route: routes.rolesPermissions,
                    base: "roles-permissions",
                  },
                ],
              },
              {
                menuValue: "Reports",
                base: "reports",
                customSubmenuTwo: true,
                subMenusTwo: [
                  {
                    menuValue: "Expense Report",
                    route: "/reports/expenses-report",
                    base: "expenses-report",
                  },
                  {
                    menuValue: "Invoice Report",
                    route: "/reports/invoice-report",
                    base: "invoice-report",
                  },
                  {
                    menuValue: "Payment Report",
                    route: "/reports/payment-report",
                    base: "payment-report",
                  },
                  {
                    menuValue: "Project Report",
                    route: "/reports/project-report",
                    base: "project-report",
                  },
                  {
                    menuValue: "Task Report",
                    route: "/reports/task-report",
                    base: "task-report",
                  },
                  {
                    menuValue: "User Report",
                    route: "/reports/user-report",
                    base: "user-report",
                  },
                  {
                    menuValue: "Employee Report",
                    route: "/reports/employee-report",
                    base: "employee-report",
                  },
                  {
                    menuValue: "Payslip Report",
                    route: "/reports/payslip-report",
                    base: "payslip-report",
                  },
                  {
                    menuValue: "Attendance Report",
                    route: "/reports/attendance-report",
                    base: "attendance-report",
                  },
                  {
                    menuValue: "Leave Report",
                    route: "/reports/leave-report",
                    base: "leave-report",
                  },
                  {
                    menuValue: "Daily Report",
                    route: "/reports/daily-report",
                    base: "daily-report",
                  },
                ],
              },
              {
                menuValue: "General Settings",
                customSubmenuTwo: true,
                base: "general-settings",
                subMenusTwo: [
                  {
                    menuValue: "Profile",
                    route: routes.profilesettings,
                    base: "profile-settings",
                    hasSubRoute: false,
                    showSubRoute: false,
                  },
                  {
                    menuValue: "Security",
                    route: routes.securitysettings,
                    base: "security-settings",
                    hasSubRoute: false,
                    showSubRoute: false,
                  },
                  {
                    menuValue: "Notifications",
                    route: routes.notificationssettings,
                    base: "notification-settings",
                    hasSubRoute: false,
                    showSubRoute: false,
                  },
                  {
                    menuValue: "Connected Apps",
                    route: routes.connectedApps,
                    base: "connected-apps",
                    hasSubRoute: false,
                    showSubRoute: false,
                  },
                ],
              },
              {
                menuValue: "Website Settings",
                customSubmenuTwo: true,
                base: "website-settings",
                subMenusTwo: [
                  {
                    menuValue: "Business Settings",
                    route: routes.bussinessSettings,
                    base: "bussiness-settings",
                  },
                  {
                    menuValue: "SEO Settings",
                    route: routes.seoSettings,
                    base: "seo-settings",
                  },
                  {
                    menuValue: "Localization",
                    route: routes.localizationSettings,
                    base: "localization-settings",
                  },
                  {
                    menuValue: "Prefixes",
                    route: routes.prefixes,
                    base: "prefixes",
                  },
                  {
                    menuValue: "Preferences",
                    route: routes.preference,
                    base: "preferences",
                  },
                  {
                    menuValue: "Appearance",
                    route: routes.appearance,
                    base: "appearance",
                  },
                  {
                    menuValue: "Language",
                    route: routes.language,
                    base: "language",
                    base2: "add-language",
                  },
                  {
                    menuValue: "Authentication",
                    route: routes.authenticationSettings,
                    base: "authentication-settings",
                  },
                  {
                    menuValue: "AI Settings",
                    route: routes.aiSettings,
                    base: "ai-settings",
                  },
                ],
              },
              {
                menuValue: "App Settings",
                customSubmenuTwo: true,
                base: "app-settings",
                subMenusTwo: [
                  {
                    menuValue: "Salary Settings",
                    route: routes.salarySettings,
                    base: "salary-settings",
                  },
                  {
                    menuValue: "Approval Settings",
                    route: routes.approvalSettings,
                    base: "approval-settings",
                  },
                  {
                    menuValue: "Invoice Settings",
                    route: routes.invoiceSettings,
                    base: "invoice-settings",
                  },
                  {
                    menuValue: "Leave Type",
                    route: routes.leaveType,
                    base: "leave-type",
                  },
                  {
                    menuValue: "Custom Fields",
                    route: routes.customFields,
                    base: "custom-fields",
                  },
                ],
              },
              {
                menuValue: "System Settings",
                customSubmenuTwo: true,
                base: "system-settings",
                subMenusTwo: [
                  {
                    menuValue: "Email Settings",
                    route: routes.emailSettings,
                    base: "email-settings",
                  },
                  {
                    menuValue: "Email Templates",
                    route: routes.emailTemplates,
                    base: "email-template",
                  },
                  {
                    menuValue: "SMS Settings",
                    route: routes.smsSettings,
                    base: "sms-settings",
                  },
                  {
                    menuValue: "SMS Templates",
                    route: routes.smsTemplate,
                    base: "sms-template",
                  },
                  {
                    menuValue: "OTP",
                    route: routes.otpSettings,
                    base: "otp-settings",
                  },
                  {
                    menuValue: "GDPR Cookies",
                    route: routes.gdprCookies,
                    base: "gdpr",
                  },
                  {
                    menuValue: "Maintenance Mode",
                    route: routes.maintenanceMode,
                    base: "maintenance-mode",
                  },
                ],
              },
              {
                menuValue: "Financial Settings",
                customSubmenuTwo: true,
                base: "financial-settings",
                subMenusTwo: [
                  {
                    menuValue: "Payment Gateways",
                    route: routes.paymentGateways,
                    base: "payment-gateways",
                  },
                  {
                    menuValue: "Tax Rate",
                    route: routes.taxRates,
                    base: "tax-rates",
                  },
                  {
                    menuValue: "Currencies",
                    route: routes.currencies,
                    base: "currencies",
                  },
                ],
              },
              {
                menuValue: "Other Settings",
                customSubmenuTwo: true,
                base: "other-settings",
                subMenusTwo: [
                  {
                    menuValue: "Custom CSS",
                    route: routes.customCss,
                    base: "custom-css",
                  },
                  {
                    menuValue: "Custom JS",
                    route: routes.customJs,
                    base: "custom-js",
                  },
                  {
                    menuValue: "Cronjob",
                    route: routes.cronjob,
                    base: "cronjob",
                  },
                  {
                    menuValue: "Storage",
                    route: routes.storage,
                    base: "storage-settings",
                  },
                  {
                    menuValue: "Ban IP Address",
                    route: routes.banIpAddress,
                    base: "ban-ip-address",
                  },
                  {
                    menuValue: "Backup",
                    route: routes.backup,
                    base: "backup",
                  },
                  {
                    menuValue: "Clear Cache",
                    route: routes.clearcache,
                    base: "clear-cache",
                  },
                ],
              },
            ],
          },
          {
            menuValue: "Configuration",
            hasSubRoute: true,
            showSubRoute: false,
            icon: "user-star",
            base: "config",
            subMenus: [
              {
                menuValue: "Configuration",
                route: routes.configuration,
                base: "leads",
              },
            ],
          },
        ],
      },
    ];
  } else {
    return [];
  }
};
